<script setup lang="ts">
import type { PropertyAreaProps } from '.';

defineProps<PropertyAreaProps>();

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');
</script>

<template>
	<IntervalInput
		v-model:min="min"
		v-model:max="max"
		title="Área útil"
		unit="area"
		min-label="Área mínima"
		max-label="Área máxima"
		update-on="blur"
		input-classes="border border-white-dark-4 hover:border-primary/40 focus:border-primary hover:focus:border-primary focus-visible:ring-0"
	/>
</template>
